<template>
  <div class="report-breadcrumb mb-2">
      <router-link to="/" style="text-transform: uppercase; font-size: 19px">{{ $tc('report', 2) }}</router-link> > <router-link :to="$route.path">{{ $t($route.name.split(" ").join("_").toLowerCase()) }}</router-link>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass">
.report-breadcrumb
  font-style: normal
  font-weight: normal
  font-size: 16px
  line-height: 30px
  color: #85888F
  a
    line-height: 30px
    font-weight: normal!important
    color: #777!important
    &.router-link-exact-active
      color: #777!important
      font-size: 13px
</style>